module.exports = __webpack_public_path__ + "img/indu_active_11.ae9bae0c.png";